import { useQuery } from '@tanstack/react-query'
import { useEffect, useMemo } from 'react'
import { useNotification } from '~/context/notification'
import { isValidRoute } from '~/services/locationService'
import { GenericClientError } from '~/utils/errors'

export function useValidRouteQuery(
  partnerId: string,
  fromAirportCode?: string,
  toAirportCode?: string
) {
  const { addErrorCodeNotification } = useNotification()

  const { data, isLoading, error, isError } = useQuery({
    queryKey: ['validRoute', partnerId, ...[fromAirportCode, toAirportCode].sort()],
    queryFn: async () =>
      isValidRoute(fromAirportCode as string, partnerId, toAirportCode as string),
    enabled: !!fromAirportCode && !!toAirportCode,
  })

  useEffect(() => {
    if (isError && error instanceof GenericClientError) {
      addErrorCodeNotification('FLIGHTS_VALID_ROUTE_ERROR', {
        type: 'ERROR',
        errorCode: error.code,
        statusCode: error.httpStatus,
      })
    }
  }, [isError, error, addErrorCodeNotification])

  return useMemo(() => ({ isRouteValid: data, isValidatingRoute: isLoading }), [data, isLoading])
}
